import {Component, OnInit} from '@angular/core';
import {SettingsService} from '../../core/settings/settings.service';
import appInfoUi from '../../../../package.json';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
             selector: 'app-footer',
             templateUrl: './footer.component.html',
             styleUrls: ['./footer.component.scss']
           })
export class FooterComponent implements OnInit {

  public appVersionUi;
  public appVersionApi: string;

  constructor(public settings: SettingsService) {
    this.appVersionUi = appInfoUi.version;
  }

  ngOnInit() {
    this.appVersionUi = appInfoUi.version;;
  }

}
